import React from 'react'
import { MotionButton, MotionCard, MotionImage, MotionSection } from '../motion/Motion'

export default function TwoImagesSection() {
  return (
    <MotionSection className="w-full mt-6 sm:mt-10 lg:mt-[50px] pb-8 px-4 sm:px-6 lg:px-8">
      <div className="w-full ml-0 pt-6 grid gap-8 sm:gap-10 md:gap-12 justify-items-center lg:justify-items-stretch lg:w-[99.5%] lg:ml-[30px] lg:pt-[50px] lg:gap-[80px] lg:grid-cols-[2fr,1.3fr] items-stretch">
        <MotionCard className="relative w-full max-w-xl sm:max-w-none h-[242px] sm:h-[274px] md:h-[306px] lg:h-[338px] rounded-xl overflow-hidden" delay={0.02}>
          <MotionImage className="absolute inset-0">
            <img
              src="/images/sectionimages/matt cat.png"
              alt="Mat catalogue"
              className="block w-full h-full object-cover"
            />
          </MotionImage>
          <div className="absolute inset-0 z-10 flex items-center">
            <div className="text-left px-6 sm:px-10 space-y-3 max-w-md">
              <h3 className="font-bold leading-tight text-white">
                <span className="text-2xl sm:text-3xl md:text-4xl">Find Your</span>
                <br />
                <span className="block text-4xl sm:text-5xl md:text-6xl">Perfect Mat</span>
              </h3>
              <p className="text-sm sm:text-base text-white leading-relaxed max-w-sm">
                Know what you need?
                <br />
                Answer a few basic questions to find
                <br />
                the mat you need.
              </p>
              <button className="mt-3 rounded-full bg-pink-500 px-6 py-2 text-sm font-semibold text-white shadow hover:bg-pink-600 transition-colors">
                <MotionButton>Contact Us</MotionButton>
              </button>
            </div>
          </div>
        </MotionCard>

        <MotionCard className="relative w-full max-w-xl sm:max-w-none h-[242px] sm:h-[274px] md:h-[306px] lg:h-[338px] rounded-xl overflow-hidden" delay={0.07}>
          <MotionImage className="absolute inset-0">
            <img
              src="/images/sectionimages/lady holding mat.png"
              alt="Customer holding door mat"
              className="block w-full h-full object-contain object-center sm:object-left"
            />
          </MotionImage>
        </MotionCard>
      </div>
    </MotionSection>
  )
}
